import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#de6e1d",
    },
    secondary: {
      main: "#de6e1d",
    },
  },

  typography: {
    fontFamily: `"PT Sans", sans-serif`,
  },
});

export default theme;
